import * as React from 'react';
import { useTheme } from '../../../../theme';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

interface Classes {
	className?: string;
	timeInRouteClassName?: string;
	routeClassName?: string;
	circleClassName?: string;
	flightNumberClassName?: string;
}

interface Props extends Classes {
	timeInRoute: string;
	flightNumber?: string;
	mobile?: boolean;
	stopCount?: number;
}

const RouteArrow: React.FC<Props> = ({
	className,
	timeInRouteClassName,
	flightNumberClassName,
	routeClassName,
	circleClassName,
	timeInRoute,
	flightNumber,
	mobile,
	stopCount
}) => {
	const theme = useTheme('DesktopFlightRoute').RouteArrowStyles;
	const { t } = useTranslation('DesktopFlight');

	return (
		<div
			className={cn(
				theme.container,
				{
					[theme.mobile]: mobile
				},
				className
			)}
		>
			<div className={cn(theme.route, routeClassName)}>
				<div className={cn(theme.circle, circleClassName)} />

				<div className={cn(theme.timeInRoute, timeInRouteClassName)}>{timeInRoute}</div>

				<div className={cn(theme.circle, circleClassName, theme.circle_right)} />
			</div>

			{flightNumber && !stopCount && (
				<div className={cn(theme.flightNumber, flightNumberClassName)}>{flightNumber}</div>
			)}

			{stopCount > 0 && (
				<div className={cn(theme.flightNumber, theme.stop)}>
					{stopCount} {t(stopCount > 1 ? 'stops' : 'stop')}
				</div>
			)}
		</div>
	);
};

export default RouteArrow;
